import { FC } from 'react';
import { ResourcesOption } from '../../types';
import Resource from './Resource';

interface ResourceLinkProps {
  resourcesOption: ResourcesOption;
}

const ResourceLink: FC<ResourceLinkProps> = ({ resourcesOption }) => {
  return (
    <a
      rel='noreferrer'
      href={resourcesOption.href}
      className='flex items-center gap-2 h-10'
      target={resourcesOption.isExternalLink ? '_blank' : '_same'}
    >
      <Resource resourcesOption={resourcesOption} />
    </a>
  );
};

export default ResourceLink;
